export function Bell(
  props: React.DetailedHTMLProps<
    React.HTMLAttributes<HTMLDivElement>,
    HTMLDivElement
  >,
) {
  return (
    <div
      {...props}
      style={{
        ...props.style,
        width: 'fit-content',
        display: 'flex',
        margin: 0,
      }}
    >
      <svg
        width="16"
        height="20"
        viewBox="0 0 16 20"
        fill="currentColor"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M8 0C6.98329 0 6.14378 0.758643 6.01665 1.74073C5.13442 2.19107 4.35901 2.83329 3.75 3.625L3.50244 3.94683C2.84483 4.80172 2.414 5.80898 2.25 6.875L2.11628 7.74416C2.03887 8.24732 2 8.75565 2 9.26473V11.3835C2 11.9364 1.77118 12.4645 1.36788 12.8426L0.316059 13.8287C0.114408 14.0177 0 14.2818 0 14.5582V15.0625C0 15.5803 0.419733 16 0.9375 16H15.0625C15.5803 16 16 15.5803 16 15.0625V14.5582C16 14.2818 15.8856 14.0177 15.6839 13.8287L14.6321 12.8426C14.2288 12.4645 14 11.9364 14 11.3835V9.26473C14 8.75565 13.9611 8.24732 13.8837 7.74416L13.75 6.875C13.586 5.80898 13.1552 4.80172 12.4976 3.94683L12.25 3.625C11.641 2.83329 10.8656 2.19107 9.98335 1.74073C9.85622 0.758643 9.01671 0 8 0Z"
          fill="currentColor"
        />
        <path
          d="M10.8284 18.8284C10.1046 19.5523 9.10457 20 8 20C6.89543 20 5.89543 19.5523 5.17157 18.8284C4.80313 18.46 4.50623 18.02 4.30349 17.5311H11.6965C11.4938 18.02 11.1969 18.46 10.8284 18.8284Z"
          fill="currentColor"
        />
      </svg>
    </div>
  );
}
